import './App.css';
import React, { useState } from "react";
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './screens/Home';
import { Toaster } from 'react-hot-toast';
import ScreenLoading from './screens/ScreenLoading';

function App() {
  const [screenLoading, setScreenLoading] = useState(true)

  // useEffect(() => {
  //   setTimeout(() => {
  //     setScreenLoading(false)
  //   }, 2000);
  // }, [])


  return (
    <div>
      <Toaster position="top-right" />
      {/* {
        screenLoading ?
          <>
            <ScreenLoading />
          </> 
          :*/}
      <>
        <Router>
          <Routes>
            <Route element={<Home />} path="/" />
          </Routes>
        </Router>
      </>
    </div>
  );
}

export default App;